"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.normalize=function(e){return(e||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase()};
